import { contain } from 'react-container-helper';

import Options from './component';

const defaultSelected = {
	id: -1,
	label: '',
	value: '',
};

const initState = ({ selected = defaultSelected }) => ({
	selected,
});

const mapSetStateToProps = (
	{ selected },
	{
		...props,
		onSelect,
	},
	setState,
) => ({
	selected,

	...props,
	
	select(option) {
		setState({ selected: option });
		onSelect(option);
	},
});

export default contain(initState, mapSetStateToProps)(Options);



// WEBPACK FOOTER //
// ./src/components/atoms/Options/index.js